import './style.css';
import { renderDashboard } from './app.js';
import { renderChat } from './chat/chat.js';
import { renderSettings } from './settings/settings.js';

const API_BASE = '';
const API_KEY = 'dev-key';

function renderNav() {
  const path = window.location.pathname;
  return `
    <nav class="top-nav">
      <a href="/" class="logo">Aishwin Agent Harness</a>
      <div class="nav-links">
        <a href="/chat" class="${path === '/chat' ? 'active' : ''}">Chat</a>
        <a href="/builder" class="${path === '/builder' ? 'active' : ''}">Workflow Builder</a>
        <a href="/audit" class="${path === '/audit' ? 'active' : ''}">Audit</a>
        <a href="/settings" class="${path === '/settings' ? 'active' : ''}">Settings</a>
      </div>
    </nav>
  `;
}

async function renderBuilder() {
  const app = document.getElementById('app');
  app.innerHTML = renderNav() + '<div id="builder-root"></div>';
  
  const { mountBuilder } = await import('./builder/main.tsx');
  mountBuilder(document.getElementById('builder-root'));
}

function route() {
  const app = document.getElementById('app');
  const path = window.location.pathname;

  if (path === '/chat') {
    app.innerHTML = renderNav();
    renderChat(app, API_BASE, API_KEY);
  } else if (path === '/builder') {
    renderBuilder();
  } else if (path === '/audit') {
    app.innerHTML = renderNav() + renderDashboard();
  } else if (path === '/settings') {
    app.innerHTML = renderNav();
    renderSettings(app);
  } else {
    app.innerHTML = renderNav() + `
      <div class="hero">
        <h1>Agent Engineering Harness</h1>
        <p>Production-grade AI workflow engine running on Cloudflare. BYOK — Bring Your Own Key.</p>
        <div class="hero-actions">
          <a href="/settings" class="btn btn-primary">Configure Keys</a>
          <a href="/chat" class="btn btn-secondary">Start Chatting</a>
        </div>
      </div>
    `;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  route();
});

window.addEventListener('popstate', route);
